import * as types from '../services/DashboardActionType';

function dashboardReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_DASHBOARD_DATA_REQUEST:
            return { ...state, loading: true };
        case types.GET_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboardData: action.payload
            };
        case types.GET_DASHBOARD_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case types.GET_PORTFOLIO_DASHBOARD_REQUEST:
            return { ...state, portfolioLoading: true };
        case types.GET_PORTFOLIO_DASHBOARD_SUCCESS:
            return { ...state, portfolioLoading: false, portfolioData: action.payload };
        case types.GET_PORTFOLIO_DASHBOARD_FAILURE:
            return { ...state, portfolioLoading: false };

        default:
            return state;
    }
}

export default dashboardReducer;
